"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Form = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const lucide_1 = require("lucide");
const event_1 = require("@/common/event");
const ui_1 = require("@/ui/ui");
const switcher_1 = require("@/ui/switcher/switcher");
const toggle_1 = require("@/ui/toggle/toggle");
const utils_1 = require("@/common/utils/utils");
const input_1 = require("./input/input");
const select_1 = require("./select/select");
require("./form.less");
const defaultOptions = {};
class Form extends ui_1.Component {
    constructor(target, _options) {
        super(((0, jsx_runtime_1.jsx)("form", { className: "form" })), target, defaultOptions, _options);
        // events
        this._onSubmit = new event_1.Emitter();
        this._list = null;
        this._itemComponents = new Map();
        if (this._options.id)
            this._element.id = this._options.id;
        this._element.addEventListener("submit", (e) => e.preventDefault());
    }
    get id() {
        return this._options.id;
    }
    _addItem(key, item) {
        var _a;
        const itemElem = ((0, jsx_runtime_1.jsxs)("div", { className: "form-item", id: key, children: [item.description && ((0, jsx_runtime_1.jsx)("div", { className: "form-item-description", children: (0, jsx_runtime_1.jsx)("span", { children: item.description }) })), (0, jsx_runtime_1.jsxs)("div", { className: "form-item-main", children: [(0, jsx_runtime_1.jsxs)("div", { className: "form-item-label", children: [item.icon && ((0, jsx_runtime_1.jsx)("div", { className: "icon-wrapper", children: (0, lucide_1.createElement)(item.icon) })), (0, jsx_runtime_1.jsx)("span", { children: item.name })] }), (0, jsx_runtime_1.jsx)("div", { className: "form-item-control" })] })] }));
        const controlContainer = itemElem.querySelector(".form-item-control");
        const type = (_a = item.type) !== null && _a !== void 0 ? _a : "input";
        let component;
        switch (type) {
            case "input": {
                component = new input_1.Input(controlContainer, Object.assign({ defaultValue: typeof item.value === "number" ? item.value.toString() : item.value }, item.controlOptions));
                component.onInput((value) => {
                    this._list[key].value = value;
                });
                break;
            }
            case "switcher": {
                component = new switcher_1.Switcher(controlContainer, Object.assign({ defaultValue: item.value }, item.controlOptions));
                component.onDidChange(({ isActive }) => {
                    this._list[key].value = isActive;
                });
                break;
            }
            case "select": {
                component = new select_1.Select(controlContainer, Object.assign({ defaultValue: item.value }, item.controlOptions));
                component.onDidChange((value) => {
                    this._list[key].value = value;
                });
                break;
            }
            case "toggle": {
                component = new toggle_1.Toggle(controlContainer, Object.assign({ defaultValue: item.value }, item.controlOptions));
                component.onDidChange((isActive) => {
                    this._list[key].value = isActive;
                });
                break;
            }
        }
        this._itemComponents.set(key, { label: item.name, component });
        this._element.appendChild(itemElem);
    }
    registerList(list) {
        this.unregisterList();
        this._list = (0, utils_1.deepClone)(list);
        for (const [key, item] of Object.entries(this._list)) {
            this._addItem(key, item);
        }
    }
    unregisterList() {
        for (const item of this._itemComponents.values()) {
            item.component.dispose();
        }
        this._list = null;
        this._itemComponents.clear();
        this._element.innerHTML = "";
    }
    submit() {
        this._onSubmit.fire(this._list);
        return this._list;
    }
    get onSubmit() {
        return this._onSubmit.event;
    }
    dispose() {
        this.unregisterList();
        super.dispose();
    }
}
exports.Form = Form;
